export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    descList: [
      // {
      //   idx: 1,
      //   name: "상품조회",
      //   col: 1,
      //   row: 1,
      //   code: "DESC001",
      //   isSmall: false,
      // },
      // {
      //   idx: 2,
      //   name: "보류",
      //   col: 1,
      //   row: 1,
      //   code: "DESC002",
      //   isSmall: false,
      // },
      // {
      //   idx: 3,
      //   name: "주문",
      //   col: 1,
      //   row: 1,
      //   code: "DESC003",
      //   isSmall: false,
      // },
      // {
      //   idx: 4,
      //   name: "사용매출",
      //   col: 1,
      //   row: 1,
      //   code: "DESC004",
      //   isSmall: false,
      // },
      // {
      //   idx: 5,
      //   name: "카카오페이",
      //   col: 1,
      //   row: 1,
      //   code: "DESC005",
      //   isSmall: false,
      // },
      // {
      //   idx: 6,
      //   name: "네이버페이",
      //   col: 1,
      //   row: 1,
      //   code: "DESC006",
      //   isSmall: false,
      // },
      // {
      //   idx: 7,
      //   name: "반품",
      //   col: 1,
      //   row: 1,
      //   code: "DESC007",
      //   isSmall: false,
      // },
      // {
      //   idx: 8,
      //   name: "거래 복원",
      //   col: 1,
      //   row: 1,
      //   code: "DESC008",
      //   isSmall: false,
      // },
      {
        idx: 1,
        name: "보류",
        col: 1,
        row: 1,
        code: "DESC002",
        isSmall: false,
      },
      {
        idx: 2,
        name: "주문",
        col: 1,
        row: 2,
        code: "DESC003",
        isSmall: false,
      },
      {
        idx: 3,
        name: "쿠폰",
        col: 1,
        row: 2,
        code: "DESC009",
        isSmall: false,
      },
      {
        idx: 4,
        name: "전체할인",
        col: 1,
        row: 1,
        code: "DESC010",
        isSmall: false,
      },
      {
        idx: 5,
        name: "객층등록",
        col: 1,
        row: 1,
        code: "DESC011",
        isSmall: false,
      },
      {
        idx: 6,
        name: "클라우드멤버쉽 회원조회",
        col: 1,
        row: 1,
        code: "DESC012",
        isSmall: false,
      },
    ],
  },
};
